import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

/* =======================================================
   CHATBOT APIS
======================================================= */

/**
 * 1️⃣ Get last conversation or create new
 */
export async function getLastConversation(user_id, website_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("website_id", website_id);
    fd.append("rtype", "1");

    const response = await axios.post(
      `${apiBaseUrl}chatbot/get_last_conv`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );

    return response.data;
  } catch (error) {
    console.error("getLastConversation error:", error);
    return {
      status: false,
      type: "danger",
      success: "Failed to get conversation"
    };
  }
}

/**
 * 2️⃣ Load messages for a conversation
 */
export async function getMessages(conv_id, user_id, page_no = 0) {
  try {
    const fd = new FormData();
    fd.append("conv_id", conv_id);
    fd.append("user_id", user_id);
    fd.append("rtype", "1");

    const response = await axios.post(
      `${apiBaseUrl}chatbot/get_msgs/${page_no}`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );

    return response.data;
  } catch (error) {
    console.error("getMessages error:", error);
    return {
      status: false,
      type: "danger",
      success: "Failed to load messages"
    };
  }
}

/**
 * 3️⃣ Send User Message
 */
export async function sendUserMessage(conv_id, user_id, msg_txt) {
  try {
    const fd = new FormData();
    fd.append("msg_conv", conv_id);
    fd.append("user_id", user_id);
    fd.append("msg_txt", msg_txt);
    fd.append("rtype", "1");

    const response = await axios.post(
      `${apiBaseUrl}chatbot/send_msg`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("sendUserMessage error:", error);
    return {
      status: false,
      type: "danger",
      success: "Failed to send message"
    };
  }
}

/**
 * 4️⃣ Get AI reply for specific message_id
 */
export async function getAIMessage(msg_id) {
  try {
    const fd = new FormData();
    fd.append("msg_id", msg_id);
    fd.append("rtype", "1");

    const response = await axios.post(
      `${apiBaseUrl}chatbot/get_ai_msg`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );

    return response.data;
  } catch (error) {
    console.error("getAIMessage error:", error);
    return {
      status: false,
      type: "danger",
      success: "Failed to fetch AI reply"
    };
  }
}
